import { ClaimFileGetSignedUrlAdapter } from '../../../adapter';

export default async function ClaimFileGetSignedUrlUseCase(event) {

    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcc.dev.bpimsapps.com');
    const isUAT = url.includes('hcc.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionclaims.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/claim/claim-file/generate-url'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/claim/claim-file/generate-url'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/claim-file/generate-url`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/claim/claim-file/generate-url`;

    const payload = {
        ...event
    };

    // handle request
    const result = await ClaimFileGetSignedUrlAdapter(endpoint, JSON.stringify(payload));

    return result;
}
